import { AppResource } from "../../../../assets/AppResource";

function AdminHeader() {
  return (
    <div className="flex flex-row w-100 items-center font-medium">
      <div className="bg-white">
        <img
          src={AppResource.logo}
          style={{
            aspectRatio: 1,
            width: 80,
          }}
        />
      </div>
      <a className="mx-4" href="tel:+84981837406">
        +84981837406
      </a>
      <a href="mailto:info@scf.asia">info@scf.asia</a>
    </div>
  );
}

export default AdminHeader;
